const compliance = {
  'engagement_leader': 'Engagement Leader',
  'manager': 'Manager',
  'review_comments': 'Review Comments',
  'ecr_client_acceptance': 'ECR - Client Acceptance',
  'independence': 'Independence',
  'engagement_acceptance': 'Engagement Acceptance',
  'higher_risk_engagements': 'Higher Risk Engagements',
  'contracting': 'Contracting',
  'deliverables_and_disclaimers': 'Deliverables and Disclaimers',
  'documentation': 'Documentation',
  'performance_and_review': 'Performance and Review',
  'record_of_work_performed': 'Record of work performed'
}

const quality = {
  'engagement_leader_for_quality': 'Engagement Leader',
  'manager_for_quality': 'Manager',
  'clear_scope': 'Clear scope',
  'engaged_stakeholders': 'Engaged stakeholders',
  'governance_enabled': 'Governance enabled decision making',
  'focused_benefits_management': 'Focused benefits management',
  'managed_risks': 'Managed risk and opportunities',
  'smart_financing': 'Smart financing',
  'delivery_enabling_plans': 'Delivery-enabling plans',
  'active_quality': 'Active quality management',
  'agile_change_control': 'Agile change control',
  'integrated_suppliers': 'Integrated suppliers (and clients)',
  'high_performing_teams': 'High performing teams',
  'embedded_lifecycle': 'Embedded lifecycle assurance and learning',
}

const inFlight = {
  'engagement_leader_for_inFlight': 'Engagement Leader',
  'manager_for_inFlight': 'Manager',
  'value_proposition': 'Value Proposition',
  'client': 'Client',
  'contract': 'Contract',
  'talent': 'Talent',
  'delivery': 'Delivery',
  'finance': 'Finance',
  'documentation_for_quality_review_advisory': 'Documentation for quality review advisory',
}

function selectType(type) {
  if (type === 1)
    return compliance
  
  if (type === 2)
    return quality
  
  if (type === 4)
    return inFlight  
}

export default (type, merged = false) => {
  return merged === true ? { ...compliance, ...quality, ...inFlight } : selectType(type)
}
